import { Component, Input, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-impression',
  templateUrl: './impression.component.html',
  styleUrls: ['./impression.component.scss'],
})
export class ImpressionComponent implements OnInit {
  @Input() title: string;
  @Input() circuitName: string;
  @Input() numDays: number;
  @Input() numAccompagnant: number;
  @Input() nbrPeronnes: number;
  @Input() dateArrivee: string;
  @Input() dateDepart: string;
  @Input() reference: string;

  @Input() isTarifRapport: any = true;
  @Input() TablePreviewEtatTarif: any;
  @Input() TablePreviewEtatCircuit: any;

  // TablePreview =[
  //   { indexJour :null,
  //     jour: [
  //             {
  //               event: {},
  //               TarifEvent :[],
  //             }
  //           ]

  //   }
  // ]

  // TablePreviewEtatTarif = [
  //   {
  //       typeEvent :null,
  //       events :[
  //                 {
  //                   nameEvent:null,
  //                   fournisseur:null,
  //                   tarifs : []
  //                 }
  //               ]
  //   }
  // ]
  constructor(public generalService: GeneralService) {}

  ngOnInit(): void {}

  print() {
    const printContent = document.getElementById('myTable').innerHTML;
    const printHeaderPage = document.getElementById('header-page').innerHTML;
    const popupWin = window.open('', '_blank', 'width=1600,height=900');
    popupWin.document.open();
    popupWin.document.write(`
    <div>
      <div style='display:flex;justify-content: space-between;align-items: center;'>
            ${printHeaderPage}
      </div>
      <div style='display:flex;flex-direction: column;justify-content: center; width:100%;'>
          ${printContent}
      </div>
     </div>
    `);
    popupWin.document.close();
    popupWin.focus();
    popupWin.print();
    popupWin.close();
  }

  logTable() {
    console.log(this.TablePreviewEtatCircuit);
    //this.getRangeDate();
  }
}
